module.exports = __webpack_public_path__ + "static/logo_sei_footer_mobile-371f679090da843047c5a5842f5984b2.png";